import {
  Board,
  Column,
  FlushPanelContent,
  Panel,
  PanelHeader,
} from '@gamma/ui/layout';
import { ErrorBoundary } from '@gamma/ui/overlay';
import { GraphQLReqStatus } from '@gamma/ui/progress';
import { useContext, useState } from 'react';
import { Row } from 'react-table';
import { graphqlErrorRedirects } from '../../../../../shared/constants';
import { AuthContext } from '../../../../../shared/providers/AuthProvider';
import { User } from '../../../../user/queries';
import { useListUsers } from '../../../queries';

import { useUserSession } from '../../../../../shared/hooks';
import { UsersAccessToolbar, UsersTable } from './Components';

export const UsersAccess = () => {
  const { signOut } = useUserSession();
  const { user } = useContext(AuthContext);

  const {
    loading: listUsersLoading,
    error,
    data: { listUsers = [] } = {},
  } = useListUsers({
    skip: !user?.attributes?.['custom:tenant_id'],
    fetchPolicy: 'cache-and-network',
    variables: {
      tenants: [`${user?.attributes?.['custom:tenant_id']}`],
    },
  });

  const [tableSearch, setTableSearch] = useState<string>('');
  const [userSelection, setUserSelection] = useState<Row<User>[]>([]);

  const loading = listUsersLoading;

  if (loading || error) {
    return (
      <ErrorBoundary page="UsersAccess" styleClass="main">
        <Panel>
          <GraphQLReqStatus
            loading={loading}
            error={error}
            signOut={signOut}
            extended={graphqlErrorRedirects}
          />
        </Panel>
      </ErrorBoundary>
    );
  } else if (!listUsers) {
    return null;
  }

  return (
    <ErrorBoundary page="UsersAccess" styleClass="main">
      <Board data-testid="users-access-page">
        <Column>
          <Panel>
            <PanelHeader>
              <UsersAccessToolbar
                userSelection={userSelection}
                onSearchChange={setTableSearch}
                tableSearch={tableSearch}
                setUserSelection={setUserSelection}
              />
            </PanelHeader>
            <FlushPanelContent>
              <UsersTable
                users={listUsers}
                tableSearch={tableSearch}
                onRowSelection={setUserSelection}
              />
            </FlushPanelContent>
          </Panel>
        </Column>
      </Board>
    </ErrorBoundary>
  );
};
